import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { locale } from 'src/environments/locale';

import { HttpConfig } from '../config/HttpConfig';



@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private readonly config: HttpConfig, @Inject(LOCALE_ID) private Locale: string) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = this.getHeaders(request);
    const params = this.getParams(request);
    const url = this.getUrl(request.url, this.config.baseUrl);

    return next.handle(
      request.clone({headers, params, url})
    );
  }

  getHeaders(request: HttpRequest<any>): HttpHeaders {
    return request.headers
      .set('Accept-Language', locale?.language == 'fr' ? 'fr-CA' : 'en-CA')
      .set('X-Requested-With', 'XMLHttpRequest');
  }

  getParams(request: HttpRequest<any>): HttpParams {
    return request.params.set('_', Date.now().toString());
  }

  getUrl(requestUrl: string, baseUrl: string): string {
    return !/^http/.test(requestUrl) ? `${baseUrl}${requestUrl}` : requestUrl;
  }
}
